import { useState } from 'react';

const faqs = [
  {
    q: '深夜档漫画多久更新一次？',
    a: '深夜档专区每日更新，通常集中在晚间上线新章节。收藏本站或开启订阅后，第一时间就能收到最新深夜档剧情的更新提醒，追更不停更。',
  },
  {
    q: '重口味和暗黑向题材有哪些类型？',
    a: '涵盖都市诡异、悬疑烧脑、血浆恐怖、猎奇心理、暗黑人性、暗黑格斗与黑暗奇幻等多个方向，剧情带感、画风大胆，适合追求强烈叙事冲击力的读者。',
  },
  {
    q: '在嘿嘿漫画网看漫画需要注册账号吗？',
    a: '浏览和阅读公开章节无需注册即可直接观看。若希望使用收藏、追更提醒与评论等功能，则建议注册账号，以便同步你的阅读进度。',
  },
  {
    q: '为什么有的漫画标注「已完结」？',
    a: '「已完结」表示该作品已更新至最终话，可一口气阅读完整剧情；「连载中」的作品仍在持续更新，编辑部会优先推送最新章节。',
  },
  {
    q: '可以离线下载漫画阅读吗？',
    a: '目前支持在线高清阅读。离线下载功能正在优化中，后续版本将开放给注册用户使用，敬请期待。',
  },
  {
    q: '如何投稿或推荐自己喜欢的暗黑向作品？',
    a: '欢迎通过「联系我们」页面留言，将你喜爱的深夜档、重口味或暗黑向作品推荐给我们，编辑部会尽快评估并安排收录。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="border-t border-background-200/60 bg-background-100">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 md:px-6 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <h2 className="font-heading text-2xl text-foreground-950">常见问题</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            关于深夜档更新频率、重口味题材范围、账号与追更等疑问，这里都有答案。如果仍未解决，欢迎随时联系我们。
          </p>
          <a
            href="/contact"
            className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-400/50 px-5 py-2.5 text-sm text-primary-300 transition-colors hover:bg-primary-500/10"
          >
            在线留言 <i className="ri-message-3-line" aria-hidden="true"></i>
          </a>
        </div>

        <div className="lg:col-span-3">
          {faqs.map((f, idx) => (
            <div key={f.q} className="border-b border-background-200/50 last:border-0">
              <button
                type="button"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="flex w-full items-center justify-between gap-4 py-4 text-left"
                aria-expanded={openIdx === idx}
              >
                <span className="text-sm font-bold text-foreground-950">{f.q}</span>
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-foreground-600 transition-transform duration-300 ${openIdx === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-lg" aria-hidden="true"></i>
                </span>
              </button>
              {openIdx === idx && (
                <p className="pb-5 pr-8 text-sm leading-relaxed text-foreground-600">{f.a}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}